// extracted by mini-css-extract-plugin
module.exports = {"root":"Feature2_root__2nYOi","title":"Feature2_title__2nxuh","suffix":"Feature2_suffix__2KHQu","description":"Feature2_description__3w1vx"};